module.exports = __webpack_public_path__ + "img/quality-activity.658d7e1c.png";